var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('l-api-viewer',{attrs:{"apis":_vm.apis}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }